<template>
  <el-dialog
    class="detail-dialog"
    v-bind="$attrs"
    v-on="$listeners"
    top="5vh"
    width="1330px"
  >
    <div class="detail-dialog-title">
      <span>预警档案详情</span>
    </div>
    <div class="detail-content">
      <el-scrollbar class="content-scroll-wrapper" wrap-style="overflow-x: hidden;">
        <LineItem0 v-if="info.status >= 0" class="line-item" :info="info"></LineItem0>
        <LineItem1 v-if="info.status >= 0" class="line-item" :info="info"></LineItem1>
        <LineItem3 v-if="info.status >= 2 && info.status !==5" class="line-item" :info="info"></LineItem3>
        <LineItem4 v-if="info.status >= 4 && info.status !==5" class="line-item" :info="info"></LineItem4>
        <LineItem5 v-if="info.status >= 4 && info.status !==5" class="line-item" :info="info"></LineItem5>
        <LineItem6 v-if="info.status === 5" class="line-item" :info="info"></LineItem6>
      </el-scrollbar>
    </div>
  </el-dialog>
</template>

<script>
import LineItem0 from "./LineItem1";
import LineItem1 from "./LineItem2";
import LineItem3 from "./LineItem3";
import LineItem4 from "./LineItem4";
import LineItem5 from "./LineItem5";
import LineItem6 from "./LineItem6";
  export default {
    name: "DialogDetail",
    components: { LineItem0, LineItem1, LineItem4, LineItem3, LineItem5, LineItem6 },
    props: {
      info: {
        type: Object,
        default: () => ({}),
      },
    },
  };
</script>

<style scoped lang="less">
  .detail-dialog {
    &::v-deep {
      .el-dialog {
        background: #021c36;
        border: 12px solid;
        border-image: url("~@/assets/img/left-bg.png") 16;
        border-radius: 0;

        .el-dialog__header {
          padding: 0;

          .el-dialog__headerbtn {
            z-index: 1;
            .el-dialog__close {
              color: #ffffff;
              font-size: 28px;
            }
          }
        }

        .el-dialog__body {
          padding: 0;
        }
      }
    }

    .detail-dialog-title {
      position: relative;
      padding: 12px 0 16px;
      margin: 0 20px 0 26px;
      font-size: 26px;
      font-weight: 500;
      color: #ffffff;
      border-bottom: 1px solid #00b2ff;
      text-shadow: 0 0 6px #00B2FF;
      & > span {
        position: relative;
        padding-left: 14px;
        &::before {
          content: "";
          display: inline-block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          width: 4px;
          height: 26px;
          background: #00b2ff;
        }
      }
    }

    .detail-content {
      position: relative;
      height: 80vh;
      margin-left: 40px;
      margin-right: 20px;
      border-left: 1px solid #00fff6;

      &::after {
        position: absolute;
        content: "";
        left: -1px;
        bottom: -10px;
        width: 1px;
        height: 10px;
        background-color: #00fff6;
      }
    }

    .content-scroll-wrapper {
      width: 100%;
      height: 100%;
    }
  }
</style>
